import type { ShopifyAppViewState } from '../resultsNavigation'
import { ShopifyBackActionButton } from './ShopifyPageActionButtons'
import { useAppBridge } from '@shopify/app-bridge-react'
import { trackShopifyAction } from '../shopifyUiTracking'

/** Old authoring identities must never be guessed into a direct study ID. */
export function isRetiredStudyView(view: ShopifyAppViewState): boolean {
  if (view.view === 'results') return true
  if (view.view === 'study-run') return !view.studyId
  if (view.view === 'support') return Boolean(view.setupId || view.packetId)
  if (view.view !== 'study-builder') return false
  return Boolean(
    view.retired ||
    view.setupId ||
    view.forkParentPacketId ||
    view.forkChangeReason ||
    (!view.studyId && view.draftId && view.entry !== 'new'),
  )
}

export function RetiredStudyPage({ onBack }: { onBack: () => void }) {
  const shopify = useAppBridge()
  return (
    <s-page heading="This test is no longer available" inlineSize="base">
      <ShopifyBackActionButton action={{ content: 'Tests', onAction: onBack }} />
      <s-section>
        <s-paragraph>
          Tests created with the previous builder have been retired. Open Tests to view your current tests or create a
          new one.
        </s-paragraph>
        <s-button onClick={() => trackShopifyAction(shopify, 'navigate-studies', onBack)}>Open Tests</s-button>
      </s-section>
    </s-page>
  )
}
